/*
 *  -----------------------------------------------------------------------
 *    <copyright file="panel-trend-chart.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import TrendLineChart from 'views/components/core/charts/trend-line-chart';
import PanelFrame from 'views/components/core/panel-frame';

const PanelTrendChart = ({ title, data, customKey }: any) => (
    <PanelFrame title={title} toggleLegend={false}>
        {(getRef: any) => (
            <TrendLineChart
                getRef={getRef}
                title={title}
                hidePlotTitle
                data={data}
                height={350}
                customKey={customKey}
                toFixed
            />
        )}
    </PanelFrame>
);

export default PanelTrendChart;
